module.exports = __webpack_public_path__ + "img/appraiser.00fef087.svg";